import { useEffect } from "react";
import ReactGA from 'react-ga4';

import { APP_CONFIG } from "../utils";

const usePageTracking = (location) => {
  ReactGA.initialize(APP_CONFIG.googleAnalyticsKey);

  useEffect(() => {
    document.documentElement.scrollTo(0, 0);
    // track pageview with gtag / react-ga / react-ga4, for example:
    // window.gtag("event", "page_view", {
    //   page_path: location.pathname + location.search,
    // });
    // ReactGA.pageview(window.location.pathname + window.location.search); // GA 3 method
    ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
  }, [location]);
};

export default usePageTracking;